// String.xml like to have all UI texts in one place.
// Will help when I18n comes to mind, or just to ensure same jargon in whole app.

// TODO: migrate all string from APP here!
const Strings = {
    components: {
        common: {
            issue_warning_banner:
                'Due to recent Google changes, SERP results may load more slowly than usual. We are fixing it.',
            loading: 'Preparing your drink...',
        },
        other: {
            preloader_notification: {
                // body: 'If it takes too much time to load SERP results, reload the page or try again later, please.'
                body: 'Looks like SERP results are taking more time to load, please wait...',
            },
        },
    },
    messages: {
        failure: {
            create_list_error: 'There was an error while creating new list.',
            delete_keyword_error: 'There was an error while deleting a keyword from list.',
            delete_list_error: 'There was an error while deleting a list.',
            download_error: 'Sorry, download is not working in Your browser. Try Chrome or Firefox.',
            export_error: 'There was an error while exporting Your data.',
            fetch_history_error: 'There was an error while fetching requests history data.',
            fetch_limits_error: 'There was an error while fetching Your account limit data.',
            fetch_list_detail_error: 'There was an error while fetching list detail data.',
            fetch_locations_error: 'There was an error while fetching locations data.',
            fetch_results_error: 'There was an error while fetching related keywords data.',
            fetch_serp_results_error: 'There was an error while fetching SERP data.',
            serp_unavailable_error: 'Search results are temporarily unavailable. Please try again in {seconds} s.',
            serp_pages_not_refreshed:
                '{pages} could not be refreshed, so the previous results are shown. Please try again in a minute.',
            footer_sorry: 'We are so sorry, try again later, please.',
            import_error: 'There was an error while importing Your keywords.',
            logout_error: 'There was an error while trying to log You out.',
            maintenance: 'Sorry, our services are undergoing a maintenance.',
            show_list_data_error: 'There was an error while fetching keywords from Your list.',
            show_list_data_not_found_error: 'Requested list does not exists.',
            too_many_requests_error: 'Sorry, you exceeded maximum allowed API requests per second.',
            update_list_error: 'There was an error while updating Your list.',
            delete_history: 'There was an error while deleting your history',
            download_snapshot: 'There was an error while downloading your snapshot',
        },
    },
};

export default Strings;
